import axios from 'axios';
import { SERVER_PATH } from '@/config/serverPath';

/**
 * 统一 HTTP 客户端
 *
 * - baseURL 为 SERVER_PATH（统一挂载前缀，默认 '/'），所有接口路径统一以 /api 开头
 *   （开发环境由 devServer proxy 转发，生产环境同源直连）
 * - 默认携带 Cookie（HttpOnly session），默认 30s 超时
 * - 401 统一处理：清空会话状态并跳转对应登录页（回调由 main.js 注册，避免循环依赖）
 */

let unauthorizedHandler = null;

/** 注册 401 处理器（在 main.js 中调用，传入依赖 store/router 的函数） */
export function setUnauthorizedHandler(fn) {
  unauthorizedHandler = fn;
}

const http = axios.create({
  baseURL: SERVER_PATH || '/',
  withCredentials: true,
  timeout: 30000,
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      unauthorizedHandler?.(error);
    }
    return Promise.reject(error);
  }
);

export default http;
